import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const RightQuick = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const [quickOpen, setQuickOpen] = useState(true);

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone) {
      Swal.fire({
        title: "이름, 연락처를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        address: "",
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          setLoading(false);
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div
      className={
        quickOpen
          ? "hidden xl:block fixed right-0 top-44 z-20 w-fit h-fit transition-all duration-200"
          : "hidden xl:block fixed -right-52 top-44 z-20 w-fit h-fit transition-all duration-200"
      }
    >
      <div className="absolute -left-[7.5rem] top-28 w-full h-fit flex justify-end gap-2 -rotate-90 text-center">
        <div
          onClick={() => window.scrollTo(0, 10)}
          className=" relative w-24 h-fit py-1.5 bg-secondary text-white rounded-t-md cursor-pointer"
        >
          <h5 className="glight">UP</h5>
        </div>
        <div
          onClick={() => setQuickOpen(!quickOpen)}
          className=" relative w-24 h-fit py-1.5 bg-secondary text-white rounded-t-md cursor-pointer"
        >
          <h5 className="glight">{quickOpen ? "CLOSE" : "OPEN"}</h5>
        </div>
      </div>
      <div className=" relative w-52 h-full p-4 border border-secondary rounded-md bg-white">
        <div className=" relative w-fit h-fit mx-auto mb-5">
          <img
            src="/images/quickLogo.png"
            alt="싹치워드림 로고"
            width={310}
            height={205}
          />
        </div>
        <input
          type="text"
          value={name}
          id="name3"
          placeholder="이름"
          className="!bg-secondary text-white text-center placeholder:text-white mb-2"
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="text"
          id="phone3"
          value={phone}
          maxLength={11}
          placeholder="연락처"
          className="!bg-secondary text-white text-center placeholder:text-white mb-2"
          onChange={(e) =>
            setPhone(
              e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1")
            )
          }
        />
        <button
          type="button"
          onClick={handlerPostContact}
          disabled={loading}
          className=" relative w-full h-10 px-5 pt-1 bg-point rounded-sm border border-secondary text-secondary"
        >
          <h5 className="glight">빠른&nbsp;상담&nbsp;신청</h5>
        </button>
        <div className="flex items-center gap-1.5 my-2">
          <input
            type="checkbox"
            name="privacy1"
            id="privacy1"
            defaultChecked
            readOnly
          />
          <small>개인정보처리방침동의</small>
        </div>
        <button
          type="button"
          onClick={() => (window.location.href = "tel:010-8245-7949")}
          className=" relative w-full h-fit bg-primary text-white p-3 rounded-md"
        >
          <h5 className="font-medium">
            전화상담&nbsp;문의
            <br />
            <span className="text-point">010.8245.7949</span>
          </h5>
        </button>
      </div>
      <div className=" relative w-full h-fit flex justify-center gap-3 items-center mt-3">
        <button
          type="button"
          onClick={() => window.open("https://blog.naver.com/jewde101")}
          className=" hover:-translate-y-2 transition-transform duration-200"
        >
          <img src="/images/iconBlog.png" alt="네이버 블로그 바로가기" width={60} height={60} />
        </button>
        <button
          type="button"
          onClick={() => window.open("https://open.kakao.com/o/shFXA18h")}
          className=" hover:-translate-y-2 transition-transform duration-200"
        >
          <img src="/images/iconKakao.png" alt="카카오톡 상담 바로가기" width={60} height={60} />
        </button>
      </div>
    </div>
  );
};

export default RightQuick;
